
// *  获取变现全天数据

import { useForm } from "antd/es/form/Form";
import { useOldMapConvertToNew } from "@/hooks/oldMapConvertToNew.hook";
import { useTypedDispatch, useTypedSelector } from "../../../hooks/store.hook";
import { MODAL_TYPE } from "../../../store/reducers/modalSlice";
import { DatePicker, Flex, Form, Modal, Select } from "antd";
import dayjs from 'dayjs';
import { getDataAllDayByDomain } from "@/modules/middle_off/service";
import { useState } from "react";
import { _setAlert } from "../../../components/alert";

export default function AllModal() {
    const { type, status } = useTypedSelector(state => state.modalReducer);
    const dispatch = useTypedDispatch();
    const { userData } = useTypedSelector(state => state.authReducer);
    const { domains } = userData!!;
    const [form] = useForm<{ domains: string[], queryDate: any }>();
    const [loading, setLoading] = useState(false);

    const onOk = async () => {
        try{
            setLoading(true);
            await new Promise((resolve) => setTimeout(resolve, 2000));
            await form.validateFields();
            const values = form.getFieldsValue();
            values.queryDate = (values.queryDate).format('YYYY-MM-DD');

            const result = await getDataAllDayByDomain(values);
            if(result.code === 200){
                // _message.success(result.msg || '获取成功');
                _setAlert({ type: 'success', message: '获取全天变现数据:' + (result.msg || '获取成功') });
            }else{
                _setAlert({ type: 'error', message: '获取全天变现数据失败:' + result.msg });
                // _message.error(result.msg || '获取失败')
            }
            if(!result){
                _setAlert({ type: 'error', message: '请求超时,可能是网络问题' });
            }
            setLoading(false);
            // dispatch({ type: "modal/hideModal" });

        }catch(err: any) {
            if(err.errorFields){
                err.errorFields.forEach((v:any) => {
                    // _message.error(v.errors.join(','))
                    _setAlert({ type: 'error', message: '获取全天变现数据失败: ' + (v.errors.join(',')) });
                })
            }
            setLoading(false);
        }
    }

    const onCancel = () => {
        dispatch({ type: "modal/hideModal"})
    }

    const filter = (inputValue: string, path: any) => {
        const isArray = Array.isArray(path);
        switch (isArray) {
            case true:
                const inputs = inputValue.split('/');
                return inputs.length > 1  ? path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1) : path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            default:
                return path.label?.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        }
    }


    return <Modal title="获取变现数据" onOk={onOk} open={status && type === MODAL_TYPE.all} onCancel={onCancel} cancelText={'关闭'} okText={`${loading ? '获取中...' : '确定'}`}>
        <Form form={form} layout="inline" initialValues={{ queryDate: dayjs() }}>
            <Flex vertical={true} gap="large">
                <Form.Item style={{minWidth: 300}} label="域名" name='domains' required={true} rules={[{ required: true, message: '域名不能为空' }]}>
                    <Select mode="multiple" listHeight={400} filterOption={filter} allowClear={true} showSearch={true} placeholder="域名" options={useOldMapConvertToNew(domains, [['domain', 'label'], [ 'domain', 'value' ]])?.sort((a:any, b: any) => a?.label?.localeCompare(b?.label))}></Select>
                </Form.Item>
                <Form.Item name="queryDate" label="日期" required={true} rules={[{ required: true, message: '日期不能为空' }]}>
                    <DatePicker></DatePicker>
                </Form.Item>
            </Flex>
        </Form>
    </Modal>
}
